import { usingGet, createProxyUrl } from '@ocean/api'
import { SessionUtils } from '@ocean/utils'

export const getRequirementDetails = (competenceId: Guid) =>
  usingGet(`requirements/details/${competenceId}`, { useProxy: true })

export const createGuidelinesDownloadUrl = (competenceId: Guid) => {
  const sessionToken = SessionUtils.getSessionToken() || ''
  return createProxyUrl(
    `Requirements/Guidelines?competenceId=${competenceId}&token=${sessionToken}`
  )
}
